export default "__VITE_ASSET__Dg$3b1x6__"